<template>
  <fields-list
    :fields="fields"
    :editing-data="editingData"
    @update-field="updateField($event.value, $event.field)"
  />
</template>

<script>
import { listsMixin } from "@/mixins/listsMixin";
import { objectManagementMixin } from "@/mixins/objectManagementMixin";
import FieldsList from "@/newComponents/StockManagement/FieldsList.vue";

export default {
  name: "MaterialFieldsDrawer",

  components: {
    FieldsList,
  },

  mixins: [listsMixin, objectManagementMixin],

  props: {
    /**
     * The specific fields values passed by the parent component
     */
    familySpecificFields: {
      type: Array | Object,
      required: true
    },

    editingData: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {

    };
  },

  /**
   * Executed when the component is mounted
   * It's a preemptive verification
   *
   */
  mounted() {
    // temporary values while the fields are not visible in the form
    if (!this.familySpecificFields.smdw_network_level) {
      this.familySpecificFields.smdw_network_level = "1";
    }
    if (!this.familySpecificFields.smdw_installation_type) {
      this.familySpecificFields.smdw_installation_type = "1";
    }
  },

  watch: {
    editingData() {
      this.requiredFieldsFilled();
    }
  },

  computed: {
    fields() {
      return [
        {
          label: this.$i18n.t("Capacity") + " (" + this.$i18n.tc("Fiber", 2) + ")",
          value: this.familySpecificFields.smdw_capacity,
          varName: 'smdw_capacity',
          inputType: 'number',
          disabled: false,
          required: true,
          step: '1',
          min: '1',
        },
        {
          label: this.$i18n.t("Dimension") + " (U)",
          value: this.familySpecificFields.smdw_dimension,
          varName: 'smdw_dimension',
          inputType: 'number',
          disabled: false,
          required: true,
          step: '1',
          min: '1',
        },
        {
          label: this.$i18n.t("NrTrays"),
          value: this.familySpecificFields.smdw_trays_nr,
          varName: 'smdw_trays_nr',
          inputType: 'number',
          disabled: false,
          required: true,
          step: '1',
          min: '1',
        },
        {
          label: this.$i18n.t("TraysSize"),
          value: this.familySpecificFields.smdw_trays_size,
          varName: 'smdw_trays_size',
          inputType: 'number',
          disabled: false,
          required: true,
          step: '1',
          min: '1',
        },
      ]
    }
  },

  methods: {
    /**
     * Validations for the various required fields
     *
     * @return {boolean} indicating if the fields are valid
     */
    requiredFieldsValidation() {
      return (
        !!this.familySpecificFields.smdw_capacity && this.familySpecificFields.smdw_capacity >= 1 &&
        !!this.familySpecificFields.smdw_trays_nr && this.familySpecificFields.smdw_capacity >= 1 &&
        !!this.familySpecificFields.smdw_trays_size && this.familySpecificFields.smdw_trays_size >= 1 &&
        !!this.familySpecificFields.smdw_dimension && this.familySpecificFields.smdw_dimension >= 1
        // !!this.familySpecificFields.smdw_installation_type &&
      );
    },

    // /**
    //  * Loads the different types of installation options and assigns them to the attribute installationTypeOptions
    //  */
    //  async loadInstallationTypeOptions({ callback }) {
    //   // try {
    //   //   this.installationTypeOptions = await this.getList(
    //   //     "list_microduct_installation_type",
    //   //     this.familySpecificFields.microduct_installation_type,
    //   //     false
    //   //   );
    //   // } finally {
    //   //   callback();
    //   // }
    //   this.installationTypeOptions = [
    //     {
    //       id: 'PN',
    //       label: 'PN'
    //     },
    //     {
    //       id: 'OLT',
    //       label: 'OLT'
    //     },
    //   ]
    // },
  }
};
</script>


// WEBPACK FOOTER //
// src/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsDrawer.vue